// extracted by mini-css-extract-plugin
export var container = "header-module--container--7sDgj";
export var copyText = "header-module--copyText--UWn+c";
export var fadein = "header-module--fadein--DRC4H";
export var header = "header-module--header--aQ2aa";
export var text = "header-module--text--tL6IC";
export var title = "header-module--title--yZ4Os";
export var visual = "header-module--visual--cEr3G";